<template>
<v-card tile elevation="0">
    <v-card-text class="pb-0">
        <v-layout align-center>
            <v-flex xs12 sm2>옵션깊이</v-flex>
            <v-flex grow-shrink-0><v-select v-model="optionCount" :items="optionCountItems" item-text="text" item-value="value" outlined dense hide-details></v-select></v-flex>
        </v-layout>
    </v-card-text>

    <v-divider class="mt-4" />

    <v-card-text class="pb-0">
        <v-layout>
            <v-flex xs12 sm2>옵션입력</v-flex>
            <v-flex xs12 sm10>
                <v-layout>
                    <v-flex xs5 class="text-center">옵션명</v-flex>
                    <v-flex xs5 class="text-center">옵션값</v-flex>
                    <v-flex xs2></v-flex>
                </v-layout>
                <v-divider class="mt-2"/>
                <v-layout v-for="(i, index) in optionCount" :key="index" class="mt-2 mx-n1">
                    <v-flex xs5 class="px-1">
                        <v-text-field v-model="optionGroups[index].name" dense hide-details outlined :placeholder="placeholders[index].name"></v-text-field>
                    </v-flex>
                    <v-flex xs5 class="px-1">
                        <v-text-field v-model="optionGroups[index].value" dense hide-details outlined :placeholder="placeholders[index].value"></v-text-field>
                    </v-flex>
                    <v-flex xs2 class="px-1">
                        <v-btn v-if="1 < optionCount" color="white" class="px-1 mr-1 primary--text" width="36" style="min-width: auto" @click="optionCount--"><v-icon>mdi-minus</v-icon></v-btn>
                    </v-flex>
                </v-layout>
                <v-layout class="mt-2 mx-n1">
                    <v-flex xs10 class="px-1">
                        <v-btn width="100%" color="primary" dark @click="generate()">옵션목록으로 적용<v-icon small class="ml-2">mdi-chevron-down</v-icon></v-btn>
                    </v-flex>
                    <v-flex xs2 class="px-1">
                        <v-btn v-if="optionCount < optionCountItems.length" width="36" color="primary" class="px-1" style="min-width: auto" @click="optionCount++"><v-icon>mdi-plus</v-icon></v-btn>
                    </v-flex>
                </v-layout>
            </v-flex>
        </v-layout>
    </v-card-text>

    <v-divider class="mt-4"></v-divider>

    <v-card-text class="pb-0">
        <v-layout>
            <v-flex xs12 sm2>옵션목록</v-flex>
            <v-flex xs12 sm10>
                <v-layout class="mx-n1">
                    <v-spacer></v-spacer>
                    <v-flex class="px-1">
                        <v-select v-model="header.operator" :items="operatorItems" label="연산자" persistent-placeholder dense outlined hide-details class="text-center"></v-select>
                    </v-flex>
                    <v-flex class="px-1">
                        <v-text-field v-model="header.salePrice" type="number" label="판매가" persistent-placeholder dense outlined hide-details @input="header.salePrice = header.salePrice.replace(/[^0-9]/,'')"></v-text-field>
                    </v-flex>
                    <v-flex class="px-1">
                        <v-text-field v-model="header.addPrice" type="number" label="추가값" persistent-placeholder dense outlined hide-details @input="header.addPrice = header.addPrice.replace(/[^0-9]/,'')"></v-text-field>
                    </v-flex>
                    <v-flex class="px-1">
                        <v-text-field v-model="header.stock" type="number" label="재고수량" persistent-placeholder dense outlined hide-details @input="header.stock = header.stock.replace(/[^0-9]/,'')"></v-text-field>
                    </v-flex>
                    <v-flex xs2 class="px-1">
                        <v-btn color="secondary" small height="40" @click="batch">선택목록 일괄수정</v-btn>
                    </v-flex>
                </v-layout>

                <v-divider class="mt-2"/>

                <v-data-table v-model="selected" :headers="optionalProductsHeaders" :items="optionalProducts.filter(option => !option.isDeleted)" item-key="optionalValues" show-select class="mt-2">
                    <template slot="header.optionalValues">
                        <v-layout>
                            <v-flex>옵션명</v-flex>
                        </v-layout>
                        <v-divider v-if="optionalNames.length" class="my-1"></v-divider>
                        <v-layout v-if="optionalNames.length">
                            <v-flex v-for="(optionalName, index) in optionalNames" :key="index">{{ optionalName }}</v-flex>
                        </v-layout>
                    </template>

                    <v-layout slot="item.value" slot-scope="{item}">
                        <v-flex v-for="(optionalValue, index) in item.optionalValues" :key="index" class="pa-0">{{ optionalValue }}</v-flex>
                    </v-layout>

                    <template slot="item.salePrice" slot-scope="{item}">
                        <v-text-field v-model="item.salePrice" type="number" dense hide-details class="text-center"></v-text-field>
                    </template>

                    <template slot="item.addPrice" slot-scope="{item}">
                        <v-text-field v-model="item.addPrice" type="number" dense hide-details class="text-center"></v-text-field>
                    </template>

                    <template slot="item.stock" slot-scope="{item}">
                        <v-text-field v-model="item.stock" type="number" dense hide-details class="text-center"></v-text-field>
                    </template>

                    <template slot="item.actions" slot-scope="{item, index}">
                        <v-icon small @click="remove(item, index)">mdi-delete</v-icon>
                    </template>
                </v-data-table>
            </v-flex>
        </v-layout>
    </v-card-text>
</v-card>
</template>

<script>
export default {
    props: {
        value: { type: [Object, Array], default(){ return [] } },
        product: { type: Object },
        salePrice: { type: Number }
    },
    data() {
        return {
            selected: [],
            optionalProducts: this.$props.value || [],
            optionalProductsHeaders: [
                { text: "옵션값", align: "center", sortable: false, value: "optionalValues" },
                { text: "판매가", align: "center", width: 140, value: "salePrice" },
                { text: "추가값", align: "center", width: 140, value: "addPrice" },
                { text: "재고수량", align: "center", width: 140, value: "stock" },
                { text: "actions", align: "center", width: 100, sortable: false, value: "actions" }
            ],

            placeholders: [
                { name: "ex) 색상", value: "ex) 빨강, 노랑" },
                { name: "ex) 사이즈", value: "ex) S, M, L, XL" },
                { name: "ex) 시즌", value: "ex) 긴팔, 반팔" }
            ],
            
            header: {
                operator: 1,
                salePrice: 0,
                stock: 0,
                addPrice:0
            },

            optionGroups: [{ name: '', value: '' }],

            optionCount: 1,
            optionCountItems: [
                { text: "1개", value: 1 },
                { text: "2개", value: 2 },
                { text: "3개", value: 3 }
            ],

            operatorItems: [
                { text: '+', value: 1 },
                { text: '-', value: -1 }
            ],
        };
    },
    methods: {
        remove(optionalProduct){
            optionalProduct._id ? this.$set(optionalProduct, "isDeleted", true) : this.optionalProducts.splice(this.optionalProducts.indexOf(optionalProduct), 1);
        },

        generate(names = [], values = [], depth = 1){
            if(depth == 1){
                while(this.optionalProducts.some(optionalProduct => !optionalProduct.isDeleted)){
                    this.remove(this.optionalProducts.find(optionalProduct => !optionalProduct.isDeleted));
                }
                this.selected = [];
            }

            if(depth <= this.optionCount){
                let name = this.optionGroups[depth - 1].name;

                for(let value of String(this.optionGroups[depth - 1].value).split(',')){
                    if(!name.trim() || !value.trim()) continue;
                    if(depth == this.optionCount){
                        this.optionalProducts.push({
                            type: "option",
                            optionalNames: [...names, name.trim()],
                            optionalValues: [...values, value.trim()],
                            salePrice: this.salePrice,
                            stock: 0,
                            addPrice: 0
                        });
                    }
                    else this.generate([...names, name.trim()], [...values, value.trim()], depth + 1);
                }
            }
        },

        batch(){
            for(var optionalProduct of this.selected){
                optionalProduct.salePrice = +optionalProduct.salePrice + parseInt(+this.header.addPrice || 0) * this.header.operator;
                optionalProduct.stock = +optionalProduct.stock + parseInt(+this.header.stock || 0) * this.header.operator;
                optionalProduct.addPrice = +optionalProduct.addPrice + parseInt(+this.header.addPrice || 0) * this.header.operator;
            }
        }
    },
    computed: {
        optionalNames(){
            return this.optionalProducts.filter(optionalProduct => !optionalProduct.isDeleted)[0]?.optionalNames || [];
        },
    },
    watch: {
        value(){
            this.optionalProducts = this.value || [];
        },
        optionCount(){
            this.optionGroups.splice(this.optionCount, this.optionGroups.length - this.optionCount);

            for(var i=0; i < this.optionCount; i++){
                if(!this.optionGroups[i]) this.$set(this.optionGroups, i, { name: '', value: '' });
            }
        },
        optionalProducts: {
            deep: true,
            handler(){ this.$emit("input", this.optionalProducts) }
        }
    }
}
</script>

<style>
.shop-optionalProducts .v-input.text-center input { text-align: center; }
</style>
